<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"/>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="typeSelect.options" :data="typeSelect.data" ref="typeSelect"></BaseSelect>
                </CCol>
                <CCol sm="6" md="6" xl="6" v-show="typeSelect.data.model == 1 || typeSelect.data.model == 2">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
                      <div class="custom-file"
                           :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                               :accept="acceptFile" @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}</label>
                      </div>
                      <div class="valid-error"
                           v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="levelSelect.options" :data="levelSelect.data" ref="levelSelect"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                              ref="departmentsInput"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6" v-if="typeSelect.data.model == 0">
                  <div class="form-group">
                    <label for="datepicker">Chữ chạy
                      <span class="required">*</span></label>
                    <br/>
                    <CInputCheckbox custom :checked="isTextRun.data.model" @update:checked="changeIsRun($event)"
                                    addInputClasses="override-custom"></CInputCheckbox>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6"
                      v-if="(typeSelect.data.model == 0 && isTextRun.data.model == false)|| typeSelect.data.model == 1">
                  <div class="form-group">
                    <label for="datepicker">Thời lượng phát
                      <span class="required">*</span></label>
                    <br/>
                    <!-- <DatePicker locale="vi"
                      id="durationPicker"
                      mode="time"
                      :format="'HH:MM:ss'"
                      v-model="durationData"
                      :masks="{ input: 'HH:MM:ss', data: 'HH:MM:ss' }"
                      is24hr>
                    </DatePicker> -->
                    <VueTimepicker v-model="durationData" format="HH:mm:ss" :hide-clear-button="true"
                                   :second-range="validRangeTime"
                                   input-class="form-control col-xs-12 col-sm-12 col-md-12 col-xl-12"
                                   placeholder="Thời lượng phát" hour-label="Giờ" minute-label="Phút"
                                   second-label="Giây">
                    </VueTimepicker>
                    <div class="valid-error"
                         v-show="!(durationInput.data.validator ? durationInput.data.validator.isValid : true)">
                      {{ durationInput.data.validator ? durationInput.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>

                <CCol sm="12" md="12" xl="12" v-if="typeSelect.data.model == 0">
                  <BaseTextArea :options="contentInput.options" :data="contentInput.data"
                                v-model="contentInput.data.model"/>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                v-model="descriptionInput.data.model"/>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData(false)">
                  <i class="fa fa-plus"></i> Lưu lại
                </CButton>
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData(true)">
                  <i class="fa fa-send"></i> Lưu lại & Gửi tới nhóm
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary mr-2"
                  @click="resetData()"><i class="fa fa-eraser"></i> Làm mới
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import BaseTextArea from "../../base/BaseTextArea.vue";
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  name: "ScreenFileAdd",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea, DatePicker, VueTimepicker},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      durationData: {
        HH: '00',
        mm: '00',
        ss: '30'
      },
      validRangeTime: [[30, 59]],
      fileName: 'Chọn tệp',
      acceptFile: ".mp4",
      titleInput: {
        options: {
          label: "Tiêu đề tệp tin <span class='required'>*</span>",
          placeholder: "Tiêu đề tệp tin",
          maxlength: 100
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề tệp tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      durationInput: {
        data: {
          name: "duration",
          model: null,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let type = that.typeSelect.data.model;
              if ((type == 0 || type == 1) && !(that.durationData.HH == "" && that.durationData.mm == "" && that.durationData.ss == "")) {
                let duration = "";
                if (that.durationData.HH == "") {
                  duration = "00"
                } else {
                  duration = that.durationData.HH
                }

                if (that.durationData.mm == "") {
                  duration += ":00"
                } else {
                  duration += ":" + that.durationData.mm
                }

                if (that.durationData.ss == "") {
                  duration += ":00"
                } else {
                  duration += ":" + that.durationData.ss
                }

                that.durationInput.data.model = duration;
              }
              let value = that.durationInput.data.model;
              if ((value == "" || value == null) && (type == 0 || type == 1)) {
                this.isValid = false;
                this.errorMessage = "Thời lượng phát không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả tệp tin",
          placeholder: "Mô tả tệp tin",
          maxlength: 300,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      contentInput: {
        options: {
          label: "Nội dung tệp tin <span class='required'>*</span>",
          placeholder: "Nội dung tệp tin",
          rows: 5
        },
        data: {
          name: "content",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.contentInput.data.model;
              let type = that.typeSelect.data.model;
              if (value == "" && type == 0) {
                this.isValid = false;
                this.errorMessage = "Nội dung tệp tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực <span class='required'>*</span>",
          selectAllText: "Chọn lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.departmentsInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Lĩnh vực tệp tin phải được chọn";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      levelSelect: {
        options: {
          filter: false,
          label: "Mức độ ưu tiên <span class='required'>*</span>",
          selectAllText: 'Chọn mức độ ưu tiên'
        },
        data: {
          name: "level",
          items: [
            {key: "0", value: "Bình thường"},
            {key: "1", value: "Ưu tiên"},
            {key: "2", value: "Khẩn cấp"},
          ],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.levelSelect.data.model;
              if (value == "") {
                this.isValid = false;
                this.errorMessage = "Mực độ ưu tiên không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      typeSelect: {
        options: {
          filter: false,
          label: 'Loại tệp tin',
        },
        data: {
          name: "type",
          items: [
            {key: "2", value: "Video"},
            {key: "0", value: "Văn bản"},
            {key: "1", value: "Hình ảnh"},
          ],
          model: "2",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      selectedFiles: {
        data: {
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              that.validateFile();
              return this.isValid;
            }
          }
        }
      },
      isTextRun: {
        data: {
          name: "isRun",
          model: true
        }
      }
    }
  },
  methods: {
    changeIsRun: function (value) {
      this.isTextRun.data.model = value;
    },
    loadDataDepartment: function () {
      let that = this;
      that.loading.value = true
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    submitData: function (isSend) {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      if (that.typeSelect.data.model == 1 || that.typeSelect.data.model == 2) {
        isValid &= this.selectedFiles.data.validator.valid();
      }
      isValid &= this.contentInput.data.validator.valid();
      isValid &= this.durationInput.data.validator.valid();
      isValid &= this.levelSelect.data.validator.valid();
      isValid &= this.departmentsInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      let formData = new FormData();
      let data = that.$helper.setupDataSubmit(that.$data);

      if (that.typeSelect.data.model == 1 || that.typeSelect.data.model == 2) {
        formData.append("file", that.$refs.file.files[0]);
      }

      formData.append('title', data.title);
      formData.append('description', data.description);
      formData.append('fileTypeId', data.fileTypeId);
      formData.append('level', data.level);
      formData.append('type', data.type);
      formData.append('content', data.content);
      if (this.typeSelect.data.model == 0) {
        if (this.isTextRun.data.model == false) {
          formData.append('duration', data.duration);
        }
      } else {
        formData.append('duration', data.duration);
      }
      formData.append('isRun', data.isRun);
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/screen-file/addFile",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Thêm mới tệp tin thành công"});
            if (isSend) {
              that.$router.push({
                path: '/screen-editor/send-to-station.html',
                query: {fileId: response.data.data.id, sourceType: response.data.data.sourceType}
              })
            } else {
              that.$router.push('/files-screen-management/managed-files.html')
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    resetData() {
      let that = this;
      // that.$helper.setupDataResponse(that.$data, {});
      that.titleInput.data.model = "";
      that.descriptionInput.data.model = "";
      that.departmentsInput.data.model = "";
      that.contentInput.data.model = "";
      that.levelSelect.data.model = "";
      that.typeSelect.data.model = "2";
      that.selectedFiles.data.model = {
        fileName: '',
        content: '',
        size: '',
        type: ''
      }
      that.durationInput.data.model = "";
      that.fileName = "Chọn tệp";
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file.files[0];
      if (file) {
        var video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          that.durationInput.data.model = (new Date(video.duration * 1000).toISOString().substr(11, 8));
        }
        video.src = URL.createObjectURL(file);

        reader.readAsDataURL(file);
        reader.onload = function () {
          // setTimeout(function () {
          that.fileName = file.name;
          // let isValid = that.validateFile(file.type);
          // if (isValid) {
          // that.selectedFiles.data.model.fileName = file.name;
          // that.selectedFiles.data.model.type = file.type;
          // that.selectedFiles.data.model.content = reader.result.split(',')[1];
          // }
          // }, 500)
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.type = file.type;
          // console.log( that.selectedFiles.data.model)
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }
      } else {
        that.selectedFiles.data.model = {
          fileName: '',
          content: '',
          size: '',
          type: ''
        }
        that.fileName = 'Chọn tệp';
      }
    },
    validateFile(type, size) {
      let fileType = this.typeSelect.data.model;
      type = this.selectedFiles.data.model.type;
      size = this.selectedFiles.data.model.size;
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        if (fileType == 1 && (type === "image/jpeg" || type === "image/png" || type === "application/pdf")) {
          this.selectedFiles.data.validator.isValid = true;
          this.selectedFiles.data.validator.errorMessage = "";
        } else if (fileType == 2 && (type === "video/mp4")) {
          this.selectedFiles.data.validator.isValid = true;
          this.selectedFiles.data.validator.errorMessage = "";
        } else {
          this.selectedFiles.data.validator.isValid = false;
          this.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
          isValid = false;
        }
      } else {
        if (fileType == 1 || fileType == 2) {
          if (this.selectedFiles.data.model.fileName === '' && this.selectedFiles.data.validator.isValid) {
            this.selectedFiles.data.validator.isValid = false;
            this.selectedFiles.data.validator.errorMessage = "Nội dung tệp tin không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataDepartment();
  },
  watch: {
    'departmentsInput.data.model': function () {
      this.departmentsInput.data.validator.valid();
    },
    'levelSelect.data.model': function () {
      this.levelSelect.data.validator.valid();
    },
    'typeSelect.data.model': function (value) {
      if (value == 1) {
        // this.acceptFile = "image/*";
        this.acceptFile = '.jpg,.png,.pdf'
      } else if (value == 2) {
        this.acceptFile = ".mp4"
      }
      this.selectedFiles.data.model.content = '';
      this.selectedFiles.data.model.fileName = '';
      this.selectedFiles.data.model.type = '';
      this.selectedFiles.data.model.size = '';
      this.fileName = 'Chọn tệp';
    },
    'durationData': function (value) {
      if (value.HH !== '00' || value.mm !== '00') {
        this.validRangeTime = [[0, 59]];
      } else {
        this.validRangeTime = [[30, 59]];
      }
    }
  }
};
</script>
<style>
.vc-date {
  display: none !important;
}

.override-custom {
  opacity: 1 !important;
  z-index: 10 !important;
}

.vue__time-picker, .vue__time-picker input.display-time {
  width: 100% !important;
}

.vue__time-picker .dropdown, .vue__time-picker-dropdown, .vue__time-picker .dropdown .select-list, .vue__time-picker-dropdown .select-list {
  width: 20em !important;
  height: 15em !important;
}

.vue__time-picker .dropdown .hint, .vue__time-picker-dropdown .hint {
  font-size: 18px !important;
}


</style>
